import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Platform } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { WatcherService } from '../../utils/watcher/watcher.service';
import { GLOBAL_SETTINGS_LOADED } from '../../utils/watcher/watcher-event';

import has from 'lodash/has';
import size from 'lodash/size';

export interface IAdminLink {
  label: string;
  view_url?: string;
  icon?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  public admin_links: Array<IAdminLink> = [];

  public support_url: string;

  constructor(public platform: Platform, public http: HttpClient, public watcher: WatcherService) {}

  public preloadConfigJSON(): void {
    // let URL: string = "https://oohub.ordermate.online/app/assets/config.json";
    let URL: string = './assets/config.json';
    let request: Observable<any>;

    // if no cordova
    // probably running in ionic serve?
    if (!this.platform.is('cordova')) {
      URL = './assets/config.json';
    }

    request = this.http.get(URL, { responseType: 'json' });

    request.subscribe(
      (config: any) => {
        if (config) {
          // admin links
          if (has(config, 'admin_links') && size(config.admin_links)) {
            this.admin_links = config.admin_links;
          }

          // support url
          if (has(config, 'support_url') && size(config.support_url)) {
            this.support_url = config.support_url;
          }
        }

        this.watcher.broadcast(GLOBAL_SETTINGS_LOADED);
      },
      err => {
        console.log('CONFIG FAILED', err);
        // this.logger.createLog("FAILED", "ERROR:" + err.status + " URL:" + URL, 'config');
      },
    );
  }
}
